<template>
    <div ref="result">
        <div
            @click="select"
            class="p-2 cursor-pointer hover:bg-gray-100 hover:text-black text-sm rounded transition"
            :class="{ 'bg-gray-100 text-black': isHighlighted }"
        >
            <slot v-bind="$props">
                <span>{{ displayed }}</span>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        result: {
            required: true,
            type: Object
        },
        select: {
            required: true,
            type: Function
        },
        isHighlighted: {
            required: true,
            type: Boolean
        },
        displayed: {
            required: true,
            type: String
        }
    },
    watch: {
        isHighlighted(isHighlighted) {
            if(!isHighlighted) return;
            const { result } = this.$refs;
            result.scrollIntoView({behavior: "smooth", block: "center"});
        }
    }
}
</script>

<style>

</style>